export default [
  {
    symbol: '+',
    entity: '&plus;',
    name: 'Plus Sign',
    css: '\\002B',
  },
  {
    symbol: '−',
    entity: '&minus;',
    name: 'Minus Sign',
    css: '\\2212',
  },
  {
    symbol: '×',
    entity: '&times;',
    name: 'Multiplication Sign',
    css: '\\00D7',
  },
  {
    symbol: '÷',
    entity: '&divide;',
    name: 'Division Sign',
    css: '\\00F7',
  },
  {
    symbol: '=',
    entity: '&equals;',
    name: 'Equal Sign',
    css: '\\003D',
  },
  {
    symbol: '≠',
    entity: '&ne;',
    name: 'Not Equal To Sign',
    css: '\\2260',
  },
  {
    symbol: '±',
    entity: '&plusmn;',
    name: 'Plus or Minus Sign',
    css: '\\00B1',
  },
  {
    symbol: '¬',
    entity: '&not;',
    name: 'Not Sign',
    css: '\\00AC',
  },
  {
    symbol: '<',
    entity: '&lt;',
    name: 'Less-Than Sign',
    css: '\\003C',
  },
  {
    symbol: '>',
    entity: '&gt;',
    name: 'Greater-Than Sign',
    css: '\\003E',
  },
  {
    symbol: '°',
    entity: '&deg;',
    name: 'Degree Sign',
    css: '\\00B0',
  },
  {
    symbol: '¹',
    entity: '&sup1;',
    name: 'Superscript One',
    css: '\\00B9',
  },
  {
    symbol: '²',
    entity: '&sup2;',
    name: 'Superscript Two',
    css: '\\00B2',
  },
  {
    symbol: '³',
    entity: '&sup3;',
    name: 'Superscript Three',
    css: '\\00B3',
  },
  {
    symbol: 'ƒ',
    entity: '&fnof;',
    name: 'Function',
    css: '\\0192',
  },
  {
    symbol: '%',
    entity: '&percnt;',
    name: 'Percent Sign',
    css: '\\0025',
  },
  {
    symbol: '‰',
    entity: '&permil;',
    name: 'Per Mille Sign',
    css: '\\0089',
  },
  {
    symbol: '‱',
    entity: '&pertenk;',
    name: 'Per Ten Thousand Sign',
    css: '\\2031',
  },
  {
    symbol: '∀',
    entity: '&forall;',
    name: 'For All',
    css: '\\2200',
  },
  {
    symbol: '∁',
    entity: '&comp;',
    name: 'Complement',
    css: '\\2201',
  },
  {
    symbol: '∂',
    entity: '&part;',
    name: 'Partial Differential',
    css: '\\2202',
  },
  {
    symbol: '∃',
    entity: '&exist;',
    name: 'There Exists',
    css: '\\2203',
  },
  {
    symbol: '∄',
    entity: '&nexist;',
    name: 'There Does Not Exist',
    css: '\\2204',
  },
  {
    symbol: '∅',
    entity: '&empty;',
    name: 'Empty Set',
    css: '\\2205',
  },
  {
    symbol: '∇',
    entity: '&nabla;',
    name: 'Nabla',
    css: '\\2207',
  },
  {
    symbol: '∈',
    entity: '&isin;',
    name: 'Element Of',
    css: '\\2208',
  },
  {
    symbol: '∉',
    entity: '&notin;',
    name: 'Not an Element Of',
    css: '\\2209',
  },
  {
    symbol: '∋',
    entity: '&ni;',
    name: 'Contains as Member',
    css: '\\220B',
  },
  {
    symbol: '∌',
    entity: '&notni;',
    name: 'Does Not Contain as Member',
    css: '\\220C',
  },
  {
    symbol: '∏',
    entity: '&prod;',
    name: 'N-Ary Product',
    css: '\\220F',
  },
  {
    symbol: '∐',
    entity: '&coprod;',
    name: 'N-Ary Coproduct',
    css: '\\2210',
  },
  {
    symbol: '∑',
    entity: '&sum;',
    name: 'N-Ary Summation',
    css: '\\2211',
  },
  {
    symbol: '∓',
    entity: '&mnplus;',
    name: 'Minus-or-Plus Sign',
    css: '\\2213',
  },
  {
    symbol: '∔',
    entity: '&plusdo;',
    name: 'Dot Plus',
    css: '\\2214',
  },
  {
    symbol: '∖',
    entity: '&setminus;',
    name: 'Set Minus',
    css: '\\2216',
  },
  {
    symbol: '∗',
    entity: '&lowast;',
    name: 'Asterisk Operator',
    css: '\\2217',
  },
  {
    symbol: '∘',
    entity: '&compfn;',
    name: 'Ring Operator',
    css: '\\2218',
  },
  {
    symbol: '√',
    entity: '&radic;',
    name: 'Square Root',
    css: '\\221A',
  },
  {
    symbol: '∝',
    entity: '&prop;',
    name: 'Proportional To',
    css: '\\221D',
  },
  {
    symbol: '∞',
    entity: '&infin;',
    name: 'Infinity',
    css: '\\221E',
  },
  {
    symbol: '∟',
    entity: '&angrt;',
    name: 'Right Angle',
    css: '\\221F',
  },
  {
    symbol: '∠',
    entity: '&ang;',
    name: 'Angle',
    css: '\\2220',
  },
  {
    symbol: '∡',
    entity: '&angmsd;',
    name: 'Measured Angle',
    css: '\\2221',
  },
  {
    symbol: '∢',
    entity: '&angsph;',
    name: 'Spherical Angle',
    css: '\\2222',
  },
  {
    symbol: '∣',
    entity: '&mid;',
    name: 'Divides',
    css: '\\2223',
  },
  {
    symbol: '∤',
    entity: '&nmid;',
    name: 'Does Not Divide',
    css: '\\2224',
  },
  {
    symbol: '∥',
    entity: '&parallel;',
    name: 'Parallel To',
    css: '\\2225',
  },
  {
    symbol: '∦',
    entity: '&npar;',
    name: 'Not Parallel To',
    css: '\\2226',
  },
  {
    symbol: '∧',
    entity: '&and;',
    name: 'Logical And',
    css: '\\2227',
  },
  {
    symbol: '∨',
    entity: '&or;',
    name: 'Logical Or',
    css: '\\2228',
  },
  {
    symbol: '∩',
    entity: '&cap;',
    name: 'Intersection',
    css: '\\2229',
  },
  {
    symbol: '∪',
    entity: '&cup;',
    name: 'Union',
    css: '\\222A',
  },
  {
    symbol: '∫',
    entity: '&int;',
    name: 'Integral',
    css: '\\222B',
  },
  {
    symbol: '∬',
    entity: '&Int;',
    name: 'Double Integral',
    css: '\\222C',
  },
  {
    symbol: '∭',
    entity: '&iiint;',
    name: 'Triple Integral',
    css: '\\222D',
  },
  {
    symbol: '∮',
    entity: '&conint;',
    name: 'Contour Integral',
    css: '\\222E',
  },
  {
    symbol: '∯',
    entity: '&Conint;',
    name: 'Surface Integral',
    css: '\\222F',
  },
  {
    symbol: '∰',
    entity: '&Cconint;',
    name: 'Volume Integral',
    css: '\\2230',
  },
  {
    symbol: '∱',
    entity: '&cwint;',
    name: 'Clockwise Integral',
    css: '\\2231',
  },
  {
    symbol: '∲',
    entity: '&cwconint;',
    name: 'Clockwise Contour Integral',
    css: '\\2232',
  },
  {
    symbol: '∳',
    entity: '&awconint;',
    name: 'Anticlockwise Contour Integral',
    css: '\\2233',
  },
  {
    symbol: '∴',
    entity: '&there4;',
    name: 'Therefore',
    css: '\\2234',
  },
  {
    symbol: '∵',
    entity: '&because;',
    name: 'Because',
    css: '\\2235',
  },
  {
    symbol: '∶',
    entity: '&ratio;',
    name: 'Ratio',
    css: '\\2236',
  },
  {
    symbol: '∷',
    entity: '&Colon;',
    name: 'Proportion',
    css: '\\2237',
  },
  {
    symbol: '∸',
    entity: '&minusd;',
    name: 'Dot Minus',
    css: '\\2238',
  },
  {
    symbol: '∺',
    entity: '&mDDot;',
    name: 'Geometric Proportion',
    css: '\\223A',
  },
  {
    symbol: '∻',
    entity: '&homtht;',
    name: 'Homothetic',
    css: '\\223B',
  },
  {
    symbol: '∼',
    entity: '&sim;',
    name: 'Tilde Operator',
    css: '\\223C',
  },
  {
    symbol: '∽',
    entity: '&bsim;',
    name: 'Reversed Tilde',
    css: '\\223D',
  },
  {
    symbol: '∾',
    entity: '&ac;',
    name: 'Inverted Lazy S',
    css: '\\223E',
  },
  {
    symbol: '∿',
    entity: '&acd;',
    name: 'Sine Wave',
    css: '\\223F',
  },
  {
    symbol: '≀',
    entity: '&wreath;',
    name: 'Wreath Product',
    css: '\\2240',
  },
  {
    symbol: '≁',
    entity: '&nsim;',
    name: 'Not Tilde',
    css: '\\2241',
  },
  {
    symbol: '≂',
    entity: '&esim;',
    name: 'Minus Tilde',
    css: '\\2242',
  },
  {
    symbol: '≃',
    entity: '&sime;',
    name: 'Asymptotically Equal To',
    css: '\\2243',
  },
  {
    symbol: '≄',
    entity: '&nsime;',
    name: 'Not Asymptotically Equal To',
    css: '\\2244',
  },
  {
    symbol: '≅',
    entity: '&cong;',
    name: 'Approximately Equal To',
    css: '\\2245',
  },
  {
    symbol: '≆',
    entity: '&simne;',
    name: 'Approximately but Not Actually Equal To',
    css: '\\2246',
  },
  {
    symbol: '≇',
    entity: '&ncong;',
    name: 'Neither Approximately Nor Actually Equal To',
    css: '\\2247',
  },
  {
    symbol: '≈',
    entity: '&asymp;',
    name: 'Almost Equal To',
    css: '\\2248',
  },
  {
    symbol: '≉',
    entity: '&nap;',
    name: 'Not Almost Equal To',
    css: '\\2249',
  },
  {
    symbol: '≊',
    entity: '&approxeq;',
    name: 'Almost Equal or Equal To',
    css: '\\224A',
  },
  {
    symbol: '≋',
    entity: '&apid;',
    name: 'Triple Tilde',
    css: '\\224B',
  },
  {
    symbol: '≌',
    entity: '&bcong;',
    name: 'All Equal To',
    css: '\\224C',
  },
  {
    symbol: '≍',
    entity: '&asympeq;',
    name: 'Equivalent To',
    css: '\\224D',
  },
  {
    symbol: '≎',
    entity: '&bump;',
    name: 'Geometrically Equivalent To',
    css: '\\224E',
  },
  {
    symbol: '≏',
    entity: '&bumpe;',
    name: 'Difference Between',
    css: '\\224F',
  },
  {
    symbol: '≐',
    entity: '&esdot;',
    name: 'Approaches the Limit',
    css: '\\2250',
  },
  {
    symbol: '≑',
    entity: '&eDot;',
    name: 'Geometrically Equal To',
    css: '\\2251',
  },
  {
    symbol: '≒',
    entity: '&efDot;',
    name: 'Approximately Equal to or the Image Of',
    css: '\\2252',
  },
  {
    symbol: '≓',
    entity: '&erDot;',
    name: 'Image of or Approximately Equal To',
    css: '\\2253',
  },
  {
    symbol: '≔',
    entity: '&colone;',
    name: 'Colon Equals',
    css: '\\2254',
  },
  {
    symbol: '≕',
    entity: '&ecolon;',
    name: 'Equals Colon',
    css: '\\2255',
  },
  {
    symbol: '≖',
    entity: '&ecir;',
    name: 'Ring in Equal To',
    css: '\\2256',
  },
  {
    symbol: '≗',
    entity: '&cire;',
    name: 'Ring Equal To',
    css: '\\2257',
  },
  {
    symbol: '≙',
    entity: '&wedgeq;',
    name: 'Estimates',
    css: '\\2259',
  },
  {
    symbol: '≚',
    entity: '&veeeq;',
    name: 'Equiangular To',
    css: '\\225A',
  },
  {
    symbol: '≜',
    entity: '&trie;',
    name: 'Delta Equal To',
    css: '\\225C',
  },
  {
    symbol: '≟',
    entity: '&equest;',
    name: 'Questioned Equal To',
    css: '\\225F',
  },
  {
    symbol: '≡',
    entity: '&equiv;',
    name: 'Identical To',
    css: '\\2261',
  },
  {
    symbol: '≢',
    entity: '&nequiv;',
    name: 'Not Identical To',
    css: '\\2262',
  },
  {
    symbol: '≤',
    entity: '&le;',
    name: 'Less-Than or Equal To',
    css: '\\2264',
  },
  {
    symbol: '≥',
    entity: '&ge;',
    name: 'Greater-Than or Equal To',
    css: '\\2265',
  },
  {
    symbol: '≦',
    entity: '&lE;',
    name: 'Less-Than Over Equal To',
    css: '\\2266',
  },
  {
    symbol: '≧',
    entity: '&gE;',
    name: 'Greater-Than Over Equal To',
    css: '\\2267',
  },
  {
    symbol: '≨',
    entity: '&lnE;',
    name: 'Less-Than but Not Equal To',
    css: '\\2268',
  },
  {
    symbol: '≩',
    entity: '&gnE;',
    name: 'Greater-Than but Not Equal To',
    css: '\\2269',
  },
  {
    symbol: '≪',
    entity: '&Lt;',
    name: 'Much Less-Than',
    css: '\\226A',
  },
  {
    symbol: '≫',
    entity: '&Gt;',
    name: 'Much Greater-Than',
    css: '\\226B',
  },
  {
    symbol: '≬',
    entity: '&between;',
    name: 'Between',
    css: '\\226C',
  },
  {
    symbol: '≭',
    entity: '&NotCupCap;',
    name: 'Not Equivalent To',
    css: '\\226D',
  },
  {
    symbol: '≮',
    entity: '&nlt;',
    name: 'Not Less-Than',
    css: '\\226E',
  },
  {
    symbol: '≯',
    entity: '&ngt;',
    name: 'Not Greater-Than',
    css: '\\226F',
  },
  {
    symbol: '≰',
    entity: '&nle;',
    name: 'Neither Less-Than Nor Equal To',
    css: '\\2270',
  },
  {
    symbol: '≱',
    entity: '&nge;',
    name: 'Neither Greater-Than Nor Equal To',
    css: '\\2271',
  },
  {
    symbol: '≲',
    entity: '&lsim;',
    name: 'Less-Than or Equivalent To',
    css: '\\2272',
  },
  {
    symbol: '≳',
    entity: '&gsim;',
    name: 'Greater-Than or Equivalent To',
    css: '\\2273',
  },
  {
    symbol: '≴',
    entity: '&nlsim;',
    name: 'Neither Less-Than Nor Equivalent To',
    css: '\\2274',
  },
  {
    symbol: '≵',
    entity: '&ngsim;',
    name: 'Neither Greater-Than Nor Equivalent To',
    css: '\\2275',
  },
  {
    symbol: '≶',
    entity: '&lg;',
    name: 'Less-Than or Greater-Than',
    css: '\\2276',
  },
  {
    symbol: '≷',
    entity: '&gl;',
    name: 'Greater-Than or Less-Than',
    css: '\\2277',
  },
  {
    symbol: '≸',
    entity: '&ntlg;',
    name: 'Neither Less-Than Nor Greater-Than',
    css: '\\2278',
  },
  {
    symbol: '≹',
    entity: '&ntgl;',
    name: 'Neither Greater-Than Nor Less-Than',
    css: '\\2279',
  },
  {
    symbol: '≺',
    entity: '&pr;',
    name: 'Precedes',
    css: '\\227A',
  },
  {
    symbol: '≻',
    entity: '&sc;',
    name: 'Succeeds',
    css: '\\227B',
  },
  {
    symbol: '≼',
    entity: '&prcue;',
    name: 'Precedes or Equal To',
    css: '\\227C',
  },
  {
    symbol: '≽',
    entity: '&sccue;',
    name: 'Succeeds or Equal To',
    css: '\\227D',
  },
  {
    symbol: '≾',
    entity: '&prsim;',
    name: 'Precedes or Equivalent To',
    css: '\\227E',
  },
  {
    symbol: '≿',
    entity: '&scsim;',
    name: 'Succeeds or Equivalent To',
    css: '\\227F',
  },
  {
    symbol: '⊀',
    entity: '&npr;',
    name: 'Does Not Precede',
    css: '\\2280',
  },
  {
    symbol: '⊁',
    entity: '&nsc;',
    name: 'Does Not Succeed',
    css: '\\2281',
  },
  {
    symbol: '⊂',
    entity: '&sub;',
    name: 'Subset Of',
    css: '\\2282',
  },
  {
    symbol: '⊃',
    entity: '&sup;',
    name: 'Superset Of',
    css: '\\2283',
  },
  {
    symbol: '⊄',
    entity: '&nsub;',
    name: 'Not a Subset Of',
    css: '\\2284',
  },
  {
    symbol: '⊅',
    entity: '&nsup;',
    name: 'Not a Superset Of',
    css: '\\2285',
  },
  {
    symbol: '⊆',
    entity: '&sube;',
    name: 'Subset of or Equal To',
    css: '\\2286',
  },
  {
    symbol: '⊇',
    entity: '&supe;',
    name: 'Superset of or Equal To',
    css: '\\2287',
  },
  {
    symbol: '⊈',
    entity: '&nsube;',
    name: 'Neither a Subset of Nor Equal To',
    css: '\\2288',
  },
  {
    symbol: '⊉',
    entity: '&nsupe;',
    name: 'Neither a Superset of Nor Equal To',
    css: '\\2289',
  },
  {
    symbol: '⊊',
    entity: '&subne;',
    name: 'Subset of With Not Equal To',
    css: '\\228A',
  },
  {
    symbol: '⊋',
    entity: '&supne;',
    name: 'Superset of With Not Equal To',
    css: '\\228B',
  },
  {
    symbol: '⊍',
    entity: '&cupdot;',
    name: 'Multiset Multiplication',
    css: '\\228D',
  },
  {
    symbol: '⊎',
    entity: '&uplus;',
    name: 'Multiset Union',
    css: '\\228E',
  },
  {
    symbol: '⊏',
    entity: '&sqsub;',
    name: 'Square Image Of',
    css: '\\228F',
  },
  {
    symbol: '⊐',
    entity: '&sqsup;',
    name: 'Square Original Of',
    css: '\\2290',
  },
  {
    symbol: '⊑',
    entity: '&sqsube;',
    name: 'Square Image of or Equal To',
    css: '\\2291',
  },
  {
    symbol: '⊒',
    entity: '&sqsupe;',
    name: 'Square Original of or Equal To',
    css: '\\2292',
  },
  {
    symbol: '⊓',
    entity: '&sqcap;',
    name: 'Square Cap',
    css: '\\2293',
  },
  {
    symbol: '⊔',
    entity: '&sqcup;',
    name: 'Square Cup',
    css: '\\2294',
  },
  {
    symbol: '⊕',
    entity: '&oplus;',
    name: 'Circled Plus',
    css: '\\2295',
  },
  {
    symbol: '⊖',
    entity: '&ominus;',
    name: 'Circled Minus',
    css: '\\2296',
  },
  {
    symbol: '⊗',
    entity: '&otimes;',
    name: 'Circled Times',
    css: '\\2297',
  },
  {
    symbol: '⊘',
    entity: '&osol;',
    name: 'Circled Division Slash',
    css: '\\2298',
  },
  {
    symbol: '⊙',
    entity: '&odot;',
    name: 'Circled Dot Operator',
    css: '\\2299',
  },
  {
    symbol: '⊚',
    entity: '&ocir;',
    name: 'Circled Ring Operator',
    css: '\\229A',
  },
  {
    symbol: '⊛',
    entity: '&oast;',
    name: 'Circled Asterisk Operator',
    css: '\\229B',
  },
  {
    symbol: '⊝',
    entity: '&odash;',
    name: 'Circled Dash',
    css: '\\229D',
  },
  {
    symbol: '⊞',
    entity: '&plusb;',
    name: 'Squared Plus',
    css: '\\229E',
  },
  {
    symbol: '⊟',
    entity: '&minusb;',
    name: 'Squared Minus',
    css: '\\229F',
  },
  {
    symbol: '⊠',
    entity: '&timesb;',
    name: 'Squared Times',
    css: '\\22A0',
  },
  {
    symbol: '⊡',
    entity: '&sdotb;',
    name: 'Squared Dot Operator',
    css: '\\22A1',
  },
  {
    symbol: '⊢',
    entity: '&vdash;',
    name: 'Right Tack',
    css: '\\22A2',
  },
  {
    symbol: '⊣',
    entity: '&dashv;',
    name: 'Left Tack',
    css: '\\22A3',
  },
  {
    symbol: '⊤',
    entity: '&top;',
    name: 'Down Tack',
    css: '\\22A4',
  },
  {
    symbol: '⊥',
    entity: '&perp;',
    name: 'Up Tack',
    css: '\\22A5',
  },
  {
    symbol: '⊧',
    entity: '&models;',
    name: 'Models',
    css: '\\22A7',
  },
  {
    symbol: '⊨',
    entity: '&vDash;',
    name: 'True',
    css: '\\22A8',
  },
  {
    symbol: '⊩',
    entity: '&Vdash;',
    name: 'Forces',
    css: '\\22A9',
  },
  {
    symbol: '⊪',
    entity: '&Vvdash;',
    name: 'Triple Vertical Bar Right Turnstile',
    css: '\\22AA',
  },
  {
    symbol: '⊫',
    entity: '&VDash;',
    name: 'Double Vertical Bar Double Right Turnstile',
    css: '\\22AB',
  },
  {
    symbol: '⊬',
    entity: '&nvdash;',
    name: 'Does Not Prove',
    css: '\\22AC',
  },
  {
    symbol: '⊭',
    entity: '&nvDash;',
    name: 'Not True',
    css: '\\22AD',
  },
  {
    symbol: '⊮',
    entity: '&nVdash;',
    name: 'Does Not Force',
    css: '\\22AE',
  },
  {
    symbol: '⊯',
    entity: '&nVDash;',
    name: 'Negated Double Vertical Bar Double Right Turnstile',
    css: '\\22AF',
  },
  {
    symbol: '⊰',
    entity: '&prurel;',
    name: 'Precedes Under Relation',
    css: '\\22B0',
  },
  {
    symbol: '⊲',
    entity: '&vltri;',
    name: 'Normal Subgroup Of',
    css: '\\22B2',
  },
  {
    symbol: '⊳',
    entity: '&vrtri;',
    name: 'Contains as Normal Subgroup',
    css: '\\22B3',
  },
  {
    symbol: '⊴',
    entity: '&ltrie;',
    name: 'Normal Subgroup of or Equal To',
    css: '\\22B4',
  },
  {
    symbol: '⊵',
    entity: '&rtrie;',
    name: 'Contains as Normal Subgroup or Equal To',
    css: '\\22B5',
  },
  {
    symbol: '⊶',
    entity: '&origof;',
    name: 'Original Of',
    css: '\\22B6',
  },
  {
    symbol: '⊷',
    entity: '&imof;',
    name: 'Image Of',
    css: '\\22B7',
  },
  {
    symbol: '⊸',
    entity: '&mumap;',
    name: 'Multimap',
    css: '\\22B8',
  },
  {
    symbol: '⊹',
    entity: '&hercon;',
    name: 'Hermitian Conjugate Matrix',
    css: '\\22B9',
  },
  {
    symbol: '⊺',
    entity: '&intcal;',
    name: 'Intercalate',
    css: '\\22BA',
  },
  {
    symbol: '⊻',
    entity: '&veebar;',
    name: 'Xor',
    css: '\\22BB',
  },
  {
    symbol: '⊽',
    entity: '&barvee;',
    name: 'Nor',
    css: '\\22BD',
  },
  {
    symbol: '⊾',
    entity: '&angrtvb;',
    name: 'Right Angle With Arc',
    css: '\\22BE',
  },
  {
    symbol: '⊿',
    entity: '&lrtri;',
    name: 'Right Triangle',
    css: '\\22BF',
  },
  {
    symbol: '⋀',
    entity: '&xwedge;',
    name: 'N-Ary Logical And',
    css: '\\22C0',
  },
  {
    symbol: '⋁',
    entity: '&xvee;',
    name: 'N-Ary Logical Or',
    css: '\\22C1',
  },
  {
    symbol: '⋂',
    entity: '&xcap;',
    name: 'N-Ary Intersection',
    css: '\\22C2',
  },
  {
    symbol: '⋃',
    entity: '&xcup;',
    name: 'N-Ary Union',
    css: '\\22C3',
  },
  {
    symbol: '⋄',
    entity: '&diamond;',
    name: 'Diamond Operator',
    css: '\\22C4',
  },
  {
    symbol: '⋅',
    entity: '&sdot;',
    name: 'Dot Operator',
    css: '\\22C5',
  },
  {
    symbol: '⋆',
    entity: '&Star;',
    name: 'Star Operator',
    css: '\\22C6',
  },
  {
    symbol: '⋇',
    entity: '&divonx;',
    name: 'Division Times',
    css: '\\22C7',
  },
  {
    symbol: '⋈',
    entity: '&bowtie;',
    name: 'Bowtie',
    css: '\\22C8',
  },
  {
    symbol: '⋉',
    entity: '&ltimes;',
    name: 'Left Normal Factor Semidirect Product',
    css: '\\22C9',
  },
  {
    symbol: '⋊',
    entity: '&rtimes;',
    name: 'Right Normal Factor Semidirect Product',
    css: '\\22CA',
  },
  {
    symbol: '⋋',
    entity: '&lthree;',
    name: 'Left Semidirect Product',
    css: '\\22CB',
  },
  {
    symbol: '⋌',
    entity: '&rthree;',
    name: 'Right Semidirect Product',
    css: '\\22CC',
  },
  {
    symbol: '⋍',
    entity: '&bsime;',
    name: 'Reversed Tilde Equals',
    css: '\\22CD',
  },
  {
    symbol: '⋎',
    entity: '&cuvee;',
    name: 'Curly Logical Or',
    css: '\\22CE',
  },
  {
    symbol: '⋏',
    entity: '&cuwed;',
    name: 'Curly Logical And',
    css: '\\22CF',
  },
  {
    symbol: '⋐',
    entity: '&Sub;',
    name: 'Double Subset',
    css: '\\22D0',
  },
  {
    symbol: '⋑',
    entity: '&Sup;',
    name: 'Double Superset',
    css: '\\22D1',
  },
  {
    symbol: '⋒',
    entity: '&Cap;',
    name: 'Double Intersection',
    css: '\\22D2',
  },
  {
    symbol: '⋓',
    entity: '&Cup;',
    name: 'Double Union',
    css: '\\22D3',
  },
  {
    symbol: '⋔',
    entity: '&fork;',
    name: 'Pitchfork',
    css: '\\22D4',
  },
  {
    symbol: '⋕',
    entity: '&epar;',
    name: 'Equal and Parallel To',
    css: '\\22D5',
  },
  {
    symbol: '⋖',
    entity: '&ltdot;',
    name: 'Less-Than With Dot',
    css: '\\22D6',
  },
  {
    symbol: '⋗',
    entity: '&gtdot;',
    name: 'Greater-Than With Dot',
    css: '\\22D7',
  },
  {
    symbol: '⋘',
    entity: '&Ll;',
    name: 'Very Much Less-Than',
    css: '\\22D8',
  },
  {
    symbol: '⋙',
    entity: '&Gg;',
    name: 'Very Much Greater-Than',
    css: '\\22D9',
  },
  {
    symbol: '⋚',
    entity: '&leg;',
    name: 'Less-Than Equal to or Greater-Than',
    css: '\\22DA',
  },
  {
    symbol: '⋛',
    entity: '&gel;',
    name: 'Greater-Than Equal to or Less-Than',
    css: '\\22DB',
  },
  {
    symbol: '⋞',
    entity: '&cuepr;',
    name: 'Equal to or Precedes',
    css: '\\22DE',
  },
  {
    symbol: '⋟',
    entity: '&cuesc;',
    name: 'Equal to or Succeeds',
    css: '\\22DF',
  },
  {
    symbol: '⋠',
    entity: '&nprcue;',
    name: 'Does Not Precede or Equal',
    css: '\\22E0',
  },
  {
    symbol: '⋡',
    entity: '&nsccue;',
    name: 'Does Not Succeed or Equal',
    css: '\\22E1',
  },
  {
    symbol: '⋢',
    entity: '&nsqsube;',
    name: 'Not Square Image of or Equal To',
    css: '\\22E2',
  },
  {
    symbol: '⋣',
    entity: '&nsqsupe;',
    name: 'Not Square Original of or Equal To',
    css: '\\22E3',
  },
  {
    symbol: '⋦',
    entity: '&lnsim;',
    name: 'Less-Than but Not Equivalent To',
    css: '\\22E6',
  },
  {
    symbol: '⋧',
    entity: '&gnsim;',
    name: 'Greater-Than but Not Equivalent To',
    css: '\\22E7',
  },
  {
    symbol: '⋨',
    entity: '&prnsim;',
    name: 'Precedes but Not Equivalent To',
    css: '\\22E8',
  },
  {
    symbol: '⋩',
    entity: '&scnsim;',
    name: 'Succeeds but Not Equivalent To',
    css: '\\22E9',
  },
  {
    symbol: '⋪',
    entity: '&nltri;',
    name: 'Not Normal Subgroup Of',
    css: '\\22EA',
  },
  {
    symbol: '⋫',
    entity: '&nrtri;',
    name: 'Does Not Contain as Normal Subgroup',
    css: '\\22EB',
  },
  {
    symbol: '⋬',
    entity: '&nltrie;',
    name: 'Not Normal Subgroup of or Equal To',
    css: '\\22EC',
  },
  {
    symbol: '⋭',
    entity: '&nrtrie;',
    name: 'Does Not Contain as Normal Subgroup or Equal',
    css: '\\22ED',
  },
  {
    symbol: '⋮',
    entity: '&vellip;',
    name: 'Vertical Ellipsis',
    css: '\\22EE',
  },
  {
    symbol: '⋯',
    entity: '&ctdot;',
    name: 'Midline Horizontal Ellipsis',
    css: '\\22EF',
  },
  {
    symbol: '⋰',
    entity: '&utdot;',
    name: 'Up Right Diagonal Ellipsis',
    css: '\\22F0',
  },
  {
    symbol: '⋱',
    entity: '&dtdot;',
    name: 'Down Right Diagonal Ellipsis',
    css: '\\22F1',
  },
  {
    symbol: '⋲',
    entity: '&disin;',
    name: 'Element of With Long Horizontal Stroke',
    css: '\\22F2',
  },
  {
    symbol: '⋳',
    entity: '&isinsv;',
    name: 'Element of With Vertical Bar at End of Horizontal Stroke',
    css: '\\22F3',
  },
  {
    symbol: '⋴',
    entity: '&isins;',
    name: 'Small Element of With Vertical Bar at End of Horizontal Stroke',
    css: '\\22F4',
  },
  {
    symbol: '⋵',
    entity: '&isindot;',
    name: 'Element of With Dot Above',
    css: '\\22F5',
  },
  {
    symbol: '⋶',
    entity: '&notinvc;',
    name: 'Element of With Overbar',
    css: '\\22F6',
  },
  {
    symbol: '⋷',
    entity: '&notinvb;',
    name: 'Small Element of With Overbar',
    css: '\\22F7',
  },
  {
    symbol: '⋹',
    entity: '&isinE;',
    name: 'Element of With Two Horizontal Strokes',
    css: '\\22F9',
  },
  {
    symbol: '⋺',
    entity: '&nisd;',
    name: 'Contains With Long Horizontal Stroke',
    css: '\\22FA',
  },
  {
    symbol: '⋻',
    entity: '&xnis;',
    name: 'Contains With Vertical Bar at End of Horizontal Stroke',
    css: '\\22FB',
  },
  {
    symbol: '⋼',
    entity: '&nis;',
    name: 'Small Contains With Vertical Bar at End of Horizontal Stroke',
    css: '\\22FC',
  },
  {
    symbol: '⋽',
    entity: '&notnivc;',
    name: 'Contains With Overbar',
    css: '\\22FD',
  },
  {
    symbol: '⋾',
    entity: '&notnivb;',
    name: 'Small Contains With Overbar',
    css: '\\22FE',
  },
];
